
import $ from 'jquery';
import SliderNav from './includes/slide-nav';
import setupOverlay from './includes/overlay';
import stickySidebar from './includes/sticky-sidebar';
import Hamburger from './hamburger';
import equalHeight from './includes/equal-height'
import isResponsive from './includes/responsive';





Hamburger($);
$.fatNav();




window.onload = () => {
    document.querySelectorAll('.slider')
        .forEach(slider => {
            new SliderNav(slider);
        });

    setupOverlay();
};



$(document).ready(function(){

    $("a").on('click', function(event) {

        if (this.hash !== "") {
            event.preventDefault();

            var hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top - 50
            });

        }
  });
})



function buildSectionAnchorElement(index, heading) {
    var a = $("<a>");
    var name = "section" + index;
        $(heading).attr("id", name);
            a.attr("href", "#"+name);
            a.text($(heading).text());
        return a;
}

var headings = $(".primary");

var sections = headings.map(function(i,e) {
    var a = buildSectionAnchorElement(i,e);
    var p = $(e).next("p");
    var li = $("<li>");
    li.append(a);
    $("#menu").append(li);
    return li;
});





stickySidebar({
    sidebar: '#sidebar',
    headings: '.primary',
    stoppers: '.footer-gray, .meer-werk-holder',
});





$(document).ready(function() {
    const shortTextHeight = 125;
    const longTextHeight = $('.collapse-text .copyright-tekst').height();
    const $textContainer = $(".collapse-text .text.full");
    const $toggleButton = $('.read-more');

    $textContainer.height(shortTextHeight);

    $toggleButton.on('click', function() {
        $(this).toggleClass('read-more');
        $(this).toggleClass('read-less');

        $textContainer.toggleClass('open');

        if ( $textContainer.hasClass('open') ) {
            $textContainer.height(longTextHeight);
            $toggleButton.text('Minder klanten');
        } else {
            $textContainer.height(shortTextHeight);
            $toggleButton.text('Meer klanten');
        }
    });
});





function fixElementHeights () {
    let columns = 3;

    if ( isResponsive('xl') ) {
        columns = 2;
    }

    if ( isResponsive('md') ) {
        columns = 1;
    }

    equalHeight('.teamlid_textholder', columns);
}

window.addEventListener('DOMContentLoaded', fixElementHeights);
window.addEventListener('resize', fixElementHeights);

$(document).ready(function(){
    $("#melding-title").on( "click", function() {
          $("#melding-content").fadeToggle(300)
    })
    $("#melding-content").on( "click", function(){
          $("#melding-content").fadeToggle(300)
    })
})

$(document).ready(function(){
    $("#footer-melding-title").on( "click", function(){
          $("#footer-melding-content").fadeToggle(300)
    })
    $("#footer-melding-content").on( "click", function(){
          $("#footer-melding-content").fadeToggle(300)
    })
})
